import _ from 'lodash';
import React, { Component } from 'react';
import { Grid, Row, Col, Media } from 'react-bootstrap';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import './Charity.css';

class Charity extends Component {
    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.fetchScreenCharity(id);
    }

    render () {
        const { charity, auth } = this.props;

        if (!charity) {
            return (
                <h4>Loading...</h4>
            );
        }

        const {
            _id,
            title,
            imageLogo,
            imageHero,
            imageProfile,
            longDescription
        } = this.props.charity;

        const style = {
            imageHero: {
                backgroundImage: `url(${imageHero})`,
                backgroundPosition: 'center center no-repeat',
                backgroundSize: 'cover',
                minHeight: 450,
                maxHeight: 450
            },
            imageProfile: {
                backgroundImage: `url(${imageProfile})`,
                backgroundPosition: 'center center no-repeat',
                backgroundSize: 'cover',
                width: '100%',
                height: '250px'
            }
        };

        return (
            <div>
                <Header auth={auth} />
                <div style={style.imageHero}></div>
                <Grid bsClass="project-body">
                <Row className="show-grid">
                        <Col xs={12} sm={12} md={4}>
                            <Media>
                                <Media.Left align="bottom">
                                    <img
                                        className="tikki-card-xl-logo responsive-img"
                                        src={imageLogo}
                                        alt=""
                                    />
                                </Media.Left>
                                <Media.Body>
                                    {/* <Media.Heading>{title}</Media.Heading> */}
                                </Media.Body>
                            </Media>
                        </Col>
                        <Col xs={12} sm={12} md={8}>
                        <div className="project-card-body">
                                <h3>{title}</h3>
                            </div>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col xs={12} sm={12} md={12}>
                            <br />
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col xs={12} sm={12} md={6}>
                            <div className="project-card-body">
                                <div style={style.imageProfile}></div>
                            </div>
                            <div className="project-card-body">
                                {/* this is intentionally blank */}
                                <h3></h3>
                            </div>
                            <div className="project-card-body">
                                {/* <span className="tikki-orange">Immediate and Direct Impact: {impactDescShort}</span> */}
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={6}>
                            <div className="project-card-body">
                                <h3>About</h3>
                            </div>
                            <div className="project-card-body">
                                {longDescription}
                            </div>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col xs={12} sm={12} md={6}>
                            <div className="project-card-body">
                                {/* <h3>About {title}</h3> */}
                            </div>
                            <div className="project-card-body">
                                {/* {longDescription} */}
                            </div>
                        </Col>
                    </Row>
                </Grid>
                <Footer />
            </div>
        );
    };
};

function mapStateToProps({ user, charities }, ownProps) {
    return {
        user,
        charity: charities[ownProps.match.params.id]
    };
}

export default connect(mapStateToProps, actions)(Charity);



// WEBPACK FOOTER //
// ./src/components/Charities/Charity.js